































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class LoadingCircle extends Vue {
  @Prop({ default: 40 })
  width: number | string;

  @Prop({ default: 40 })
  height: number | string;

  @Prop({ default: 'center' })
  layout: 'center' | 'inline';

  toSizeMetric(value: number | string) {
    const valueString: string = value + '';

    return valueString.endsWith('px')
      ? valueString
      : valueString + 'px';
  }

  mounted() {}
}
